import { template as template_f9f48a8442044b749231191c24eb1076 } from "@ember/template-compiler";
import TriggerEventValues, { TriggerEvents } from 'eflex/constants/tasks/trigger-events';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { t } from 'ember-intl';
import { fn, get } from '@ember/helper';
import LinkInput from 'eflex/components/inputs/link-input';
import BsButton from 'eflex/components/bs-button';
import JemDynamicInstruction from 'eflex/components/jem/dynamic-instruction';
import { or, not, notEq } from 'ember-truth-helpers';
import UrlViewer from 'eflex/components/url-viewer';
import Link from 'eflex/components/link';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { optional, withDefault, dec } from '@eflexsystems/ember-composable-helpers';
import JemInstructionsAnimation from 'eflex/components/jem/instructions/animation';
import { service } from '@ember/service';
import { createTrigger } from 'eflex/services/trigger-repo';
import NoRouteTabs from 'eflex/components/no-route-tabs';
import { concat } from 'ramda';
import StandardModal from 'eflex/components/standard-modal';
import BsTooltip from 'eflex/components/bs-tooltip';
import { isBlank } from 'ramda-adjunct';
import WorkInstructionEditorLibrary from 'eflex/components/work-instruction-editor/library';
import WieSettings from 'eflex/constants/work-instructions/wie-settings';
export const deleteJemImage = (jemConfig)=>{
    Object.assign(jemConfig, {
        externalImageUrl: null,
        workInstruction: null,
        page: null,
        animations: []
    });
};
const getTriggerConfig = (triggerConfigs, triggerEvent)=>{
    return triggerConfigs?.find((triggerConfig)=>triggerConfig.constructor.modelName === 'work-instruction-hardware-trigger-config' && triggerConfig.event === triggerEvent);
};
class ConfigLocation extends Component {
    get configLocationEntries() {
        return Object.entries(this.args.configLocation).filter(([_, value])=>value);
    }
    static{
        template_f9f48a8442044b749231191c24eb1076(`
    <div class="d-flex align-items-center fs-4">
      {{#each this.configLocationEntries as |entry idx|}}
        <span class="text-gray-700 text-truncate min-w-0">
          {{get entry 1}}
        </span>
        {{#if (notEq idx (dec this.configLocationEntries.length))}}
          <span class="text-gray-700 mx-1">-</span>
        {{/if}}
      {{/each}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
const LinkToWorkInstruction = template_f9f48a8442044b749231191c24eb1076(`
{{#let
  (if @config.workInstruction "workInstructions.workInstruction")
  (if @config.workInstruction @config.workInstruction.id)
  (unless @config.workInstruction @config.fullExternalUrl)
  as |route model href|
}}
  <Link
    @route={{route}}
    @model={{model}}
    @href={{href}}
    target={{if href "_blank"}}
    rel={{if href "noopener noreferrer"}}
    class="btn btn-sm btn-peripheral"
    ...attributes
  >
    <FaIcon @icon="arrow-up-right-from-square" @prefix="fas" class="fa-fw" />
    <BsTooltip @title={{or href (t "workInstruction.openInEditor")}} />
  </Link>
{{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
class DynamicEventsModal extends Component {
    @tracked
    animationsToRun;
    playAnimation = (animation)=>{
        this.animationsToRun = [
            animation
        ];
    };
    static{
        template_f9f48a8442044b749231191c24eb1076(`
    <StandardModal
      class="dynamic-events-modal"
      @contentClass="h-100"
      @onCancel={{@onCancel}}
      @size="xl"
      ...attributes
    as |modal|>
      <modal.header class="pb-0" as |header|>
        <div class="d-flex flex-column w-100">
          <div class="d-flex align-items-center mb-1">
            <div class="flex-fill d-flex align-items-center min-w-0">
              <h5 class="modal-title lh-sm text-truncate">
                {{t "dynamicEvents"}}
              </h5>
              <span class="badge fs-3 bg-gray-400 py-1 px-2 mb-0 ms-2">
                {{@config.nonDeletedAnimationCount}}
              </span>
            </div>
            <header.close />
          </div>
          <ConfigLocation @configLocation={{@configLocation}} />
        </div>
      </modal.header>
      <modal.body class="h-100">
        <div class="row h-100">
          <div class="col h-100">
            <JemDynamicInstruction
              class="bg-gray-100"
              @workInstruction={{@config.workInstruction}}
              @animations={{this.animationsToRun}}
              @previewMode={{true}}
              @bypassDelayTime={{@bypassDelayTime}}
              @resetTimeout={{@resetTimeout}}
            />
          </div>
          <div class="col-4 h-100">
            <JemInstructionsAnimation
              class="h-100"
              @triggerConfig={{@config}}
              @boltCount={{@taskConfig.boltCount}}
              @disabled={{@disabled}}
              @playAnimation={{this.playAnimation}}
            />
          </div>
        </div>
      </modal.body>
      <modal.footer class="pt-0" as |footer|>
        <footer.close>
          {{t "close"}}
        </footer.close>
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
const ExpandPreviewModal = template_f9f48a8442044b749231191c24eb1076(`
<StandardModal
  class="expanded-preview-modal"
  @contentClass="h-100"
  @onCancel={{@onCancel}}
  @size="xl"
  ...attributes
as |modal|>
  <modal.header class="pb-0" as |header|>
    <div class="d-flex align-items-center w-100">
      <div class="flex-fill d-flex align-items-center min-w-0">
        <h5 class="modal-title lh-sm text-truncate">
          {{@title}}
        </h5>
        <LinkToWorkInstruction @config={{@config}} class="ms-2" />
      </div>
      <header.close />
    </div>
  </modal.header>
  <modal.body>
    <div class="d-flex align-items-center justify-content-center bg-gray-100 h-100 position-relative">
      {{#if @config.hasExternalUrl}}
        <UrlViewer @url={{@config.fullExternalUrl}} />
      {{else}}
        <img src={{@imageUrl}} class="img-responsive" />
      {{/if}}
    </div>
  </modal.body>
</StandardModal>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
class SelectWorkInstructionModal extends Component {
    @tracked
    activeTab = 'library';
    @tracked
    currentLibraryView = WieSettings.libraryViews.THUMB;
    @tracked
    previewUrl;
    _handleSingleSelection = (instructions)=>{
        if (instructions[0]?.isFolder) {
            return;
        }
        this.args.stashWorkInstruction(instructions[0]);
    };
    _onCancel = ()=>{
        this.previewUrl = null;
        this.args.removeStashedWorkInstruction();
        this.args.closeModal();
    };
    _tabBecameActive = (tab)=>{
        this.args.removeStashedWorkInstruction();
        this.activeTab = tab;
    };
    static{
        template_f9f48a8442044b749231191c24eb1076(`
    <StandardModal
      class="select-work-instruction-modal"
      @onConfirm={{@setWorkInstruction}}
      @onCancel={{this._onCancel}}
      @contentClass="d-flex flex-column h-100"
      @size="lg"
      ...attributes
    as |modal|>
      <modal.header class="bg-gray-100 pb-0" as |header|>
        <div class="d-flex flex-column w-100">
          <div class="d-flex align-items-center mb-1">
            <h5 class="modal-title lh-sm flex-fill min-w-0 text-truncate">
              {{t "workInstruction.select"}}
            </h5>
            <header.close />
          </div>
          <ConfigLocation @configLocation={{@configLocation}} />
        </div>
      </modal.header>
      <modal.body class="flex-fill d-flex flex-column overflow-hidden p-0">
        <NoRouteTabs
          @activeTab={{this.activeTab}}
          @tabBecameActive={{this._tabBecameActive}}
        as |tabs|>
          <tabs.navigation class="px-4 pt-4 bg-gray-100" as |nav|>
            <nav.tab @href="library" class="tab-library">
              {{t "library"}}
            </nav.tab>
            <nav.tab @href="url" class="tab-url">
              {{t "status.servers.linkUrl"}}
            </nav.tab>
          </tabs.navigation>
          <tabs.panes as |panes|>
            <panes.pane @id='library'>
              <WorkInstructionEditorLibrary
                class="task-library h-100"
                @currentWorkInstruction={{@config.workInstruction}}
                @currentLibraryView={{this.currentLibraryView}}
                @onSetLibraryView={{fn (mut this.currentLibraryView)}}
                @stashWorkInstruction={{@stashWorkInstruction}}
                @onChange={{this._handleSingleSelection}}
                @setWorkInstruction={{@setWorkInstruction}}
                @isReadOnly={{true}}
                @isModal={{true}}
                @multiselectDisabled={{true}}
                @onPdfPageInput={{@onPdfPageInput}}
              />
            </panes.pane>
            <panes.pane @id='url'>
              <div class="row flex-column g-3 h-100 p-4 pb-3">
                <div class="col-auto">
                  <LinkInput
                    @link={{@stashedWorkInstruction}}
                    @updateLink={{@stashWorkInstruction}}
                    @previewLink={{fn (mut this.previewUrl) @stashedWorkInstruction}}
                    class="image-url-field"
                  />
                </div>
                <div class="col">
                  <div class="bg-gray-100 border border-gray-200 rounded position-relative h-100">
                    <UrlViewer @url={{this.previewUrl}} />
                  </div>
                </div>
              </div>
            </panes.pane>
          </tabs.panes>
        </NoRouteTabs>
      </modal.body>
      <modal.footer class="pt-0" as |footer|>
        <footer.confirm @disabled={{isBlank @stashedWorkInstruction}}>
          {{t "apply"}}
        </footer.confirm>
        <footer.close />
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
class ConfigurationFields extends Component {
    @service
    hardwareRepo;
    @tracked
    showExpandPreviewModal = false;
    @tracked
    showDynamicEventsModal = false;
    @tracked
    showSelectWorkInstructionModal = false;
    @tracked
    stashedWorkInstruction;
    @tracked
    configPage = null;
    #getOrCreateTriggerAndConfig = (config, triggerConfig)=>{
        if (this.args.useEvent && triggerConfig == null) {
            createTrigger(this.args.taskConfig?.task, this.args.triggerEvent, this.hardwareRepo.workInstructionHardware);
            config = getTriggerConfig(this.args.taskConfig?.triggerConfigs, this.args.triggerEvent);
        }
        return config;
    };
    stashWorkInstruction = (workInstruction)=>{
        this.stashedWorkInstruction = workInstruction;
    };
    setWorkInstruction = (config, triggerConfig)=>{
        const workInstructionConfig = this.#getOrCreateTriggerAndConfig(config, triggerConfig);
        if (this.stashedWorkInstruction?.url) {
            this.stashedWorkInstruction = this.stashedWorkInstruction.url;
        }
        if (this.stashedWorkInstruction.canvas) {
            workInstructionConfig.setWorkInstruction(this.stashedWorkInstruction);
        } else {
            workInstructionConfig.setExternalImageUrl(this.stashedWorkInstruction);
            workInstructionConfig.page = this.configPage;
        }
        this.showSelectWorkInstructionModal = false;
        this.stashedWorkInstruction = null;
    };
    static{
        template_f9f48a8442044b749231191c24eb1076(`
    {{#let
      @taskConfig.task
      (getTriggerConfig @taskConfig.triggerConfigs @event)
    as |task triggerConfig|}}
      {{#let (withDefault triggerConfig @jemConfiguration) as |config|}}
        {{#let
          (or config.workInstruction.deployedImageUrl config.fullExternalUrl)
          (or config.workInstruction.deployedName config.fullExternalUrl)
          as |imageUrl imageName|
        }}
          {{#if (or config.workInstruction config.fullExternalUrl)}}
            <div class="row align-items-center" ...attributes>
              <div class="col-4 col-xl-2">
                <div class="library-thumbnail position-relative bg-gray-200 overflow-hidden rounded">
                  <div
                    class="d-flex align-items-center justify-content-center h-100">
                    {{#if config.hasExternalUrl}}
                      <div class="mw-100 mh-100">
                        <FaIcon @icon="link" @prefix="fas" class="text-gray-400" />
                      </div>
                    {{else}}
                      <img
                        class="mw-100 mh-100"
                        src={{config.workInstruction.deployedImageThumbUrl}}
                        title={{imageName}}
                      />
                    {{/if}}
                  </div>
                  <div class="position-absolute top-0 end-0 z-2">
                    <BsButton
                      class="expanded-preview d-flex shadow p-1 m-1"
                      @onClick={{fn (mut this.showExpandPreviewModal) true}}
                      @size="sm"
                    >
                      <FaIcon @icon="magnifying-glass" @prefix="fas" class="fa-fw" />
                      <BsTooltip @title={{t "preview"}} />
                    </BsButton>
                  </div>
                </div>
              </div>
              <div class="col min-w-0">
                <div class="row align-items-center">
                  <div class="col min-w-0">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center">
                        <label class="name text-truncate fw-bold fs-4">
                          {{imageName}}
                        </label>
                        <LinkToWorkInstruction @config={{config}} class="ms-1" />
                      </div>
                      {{#if config.workInstruction}}
                        <span class="type fw-semibold fs-5 text-truncate text-gray-700 lh-1">
                          {{t "plant.station.workInstructionEditor"}}
                        </span>
                      {{/if}}
                    </div>
                  </div>
                  <div class="col-auto">
                    <div class="row justify-content-end align-items-center g-2">
                      {{#unless @jemConfiguration}}
                        {{#let (not config.workInstruction.isDynamic) as |disabled|
                        }}
                          <div class="col-auto ms-auto">
                            <BsButton
                              class="dynamic-events"
                              @size="sm"
                              @onClick={{fn (mut this.showDynamicEventsModal) true}}
                              @disabled={{disabled}}
                            >
                              <div class="d-flex align-items-center">
                                {{t "dynamicEvents"}}
                                {{#unless disabled}}
                                  <span class="
                                    total-dynamic-event-count badge ms-1 px-2 py-1
                                    {{if config.nonDeletedAnimationCount "bg-primary" "bg-gray-400"}}
                                  ">
                                    {{config.nonDeletedAnimationCount}}
                                  </span>
                                {{/unless}}
                              </div>
                            </BsButton>
                            {{#if disabled}}
                              <BsTooltip @title={{if
                                config.workInstruction.isDynamic
                                (t "dynamicEvents.onlyTorqueTasks")
                                (t "dynamicEvents.noDynamicObjects")
                                }}
                              />
                            {{/if}}
                          </div>
                        {{/let}}
                      {{/unless}}
                      <div class="col-auto">
                        <BsButton
                          class="select-work-instruction replace"
                          @onClick={{fn (mut this.showSelectWorkInstructionModal) true}}
                          @size="sm"
                        >
                          {{t "replaceEllipsis"}}
                        </BsButton>
                      </div>
                      <div class="col-auto">
                        <BsButton
                          class="remove-work-instruction ms-1"
                          @onClick={{fn deleteJemImage config}}
                          @type="peripheral"
                          @size="sm"
                        >
                          <FaIcon @icon="trash" />
                          <BsTooltip @title={{t "remove"}} />
                        </BsButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          {{else}}
            <div class="row align-items-center" ...attributes>
              <div class="col-auto">
                <BsButton
                  class="select-work-instruction"
                  @size="sm"
                  @onClick={{fn (mut this.showSelectWorkInstructionModal) true}}
                >
                  {{t "workInstruction.select"}}
                </BsButton>
              </div>
              <div class="col">
                <span class="not-selected-placeholder">{{t "workInstruction.notSelected"}}</span>
              </div>
            </div>
          {{/if}}

          {{#if this.showSelectWorkInstructionModal}}
            <SelectWorkInstructionModal
              @closeModal={{fn (mut this.showSelectWorkInstructionModal) false}}
              @configLocation={{@configLocation}}
              @currentWorkInstruction={{config.workInstruction}}
              @config={{config}}
              @disabled={{@disabled}}
              @stashWorkInstruction={{this.stashWorkInstruction}}
              @stashedWorkInstruction={{this.stashedWorkInstruction}}
              @setWorkInstruction={{fn this.setWorkInstruction config triggerConfig}}
              @onPdfPageInput={{fn (mut this.configPage)}}
              @removeStashedWorkInstruction={{fn (mut this.stashedWorkInstruction) null}}
            />
          {{/if}}

          {{#if this.showDynamicEventsModal}}
            <DynamicEventsModal
              @config={{config}}
              @configLocation={{@configLocation}}
              @taskConfig={{@taskConfig}}
              @onCancel={{fn (mut this.showDynamicEventsModal) false}}
              @bypassDelayTime={{@bypassDelayTime}}
              @resetTimeout={{@resetTimeout}}
            />
          {{/if}}

          {{#if this.showExpandPreviewModal}}
            <ExpandPreviewModal
              @title={{imageName}}
              @imageUrl={{imageUrl}}
              @onCancel={{fn (mut this.showExpandPreviewModal) false}}
              @config={{config}}
            />
          {{/if}}
        {{/let}}
      {{/let}}
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default class JemInstructionsConfiguration extends Component {
    @tracked
    triggerEvent = TriggerEventValues.START;
    get configLocation() {
        if (this.args.taskConfig) {
            const config = this.args.taskConfig;
            return {
                area: config.area?.name,
                station: config.station?.name,
                task: config.task?.name,
                context: config.component?.name ? `${config.component.name} - ${config.configName}` : config.configName,
                event: this.triggerEvent
            };
        } else if (this.args.jemConfiguration) {
            const config = this.args.jemConfiguration;
            return {
                area: config.configModel?.area?.name,
                station: config.station?.name,
                context: config.configModel?.displayName
            };
        } else {
            return {};
        }
    }
    static{
        template_f9f48a8442044b749231191c24eb1076(`
    <div class="
      jem-task-config d-flex flex-column shadow rounded overflow-hidden"
      ...attributes
    >
      <div class="row bg-gray-100 p-3">
        <div class="col">
          <h6 class="context-name flex-fill mb-0">
            {{this.configLocation.context}}
          </h6>
        </div>
        {{#if (withDefault @showCopyToAll true)}}
          {{#let
            (withDefault (getTriggerConfig @taskConfig.triggerConfigs this.triggerEvent) @jemConfiguration)
            as |config|
          }}
            <div class="col-auto">
              <BsButton
                @onClick={{fn (optional @copyToAll) config this.triggerEvent @selectedContext}}
                @disabled={{or @disabled}}
                @type='secondary'
                class="test-copy-to-selected text-capitalize text-nowrap"
                @size="sm"
              >
                {{#if @usesComponents}}
                  {{t "copyOptionSpecificSelected"}}
                {{else}}
                  {{t "copyModelSpecificSelected"}}
                {{/if}}
              </BsButton>
            </div>
          {{/let}}
        {{/if}}
      </div>

      {{#if @useEvent}}
        <NoRouteTabs
          @activeTab={{this.triggerEvent}}
          @tabBecameActive={{fn (mut this.triggerEvent)}}
        as |tabs|>
          <tabs.navigation class="bg-gray-100 border-gray-200 mb-0" as |nav|>
            {{#each TriggerEvents as |event|}}
              <nav.tab @href={{event}} class={{concat "tab-" event}}>
                {{t event}}
              </nav.tab>
            {{/each}}
          </tabs.navigation>
          <tabs.panes class="p-3" as |panes|>
            {{#each TriggerEvents as |event|}}
              <panes.pane @id={{event}}>
                <ConfigurationFields
                  @configLocation={{this.configLocation}}
                  @taskConfig={{@taskConfig}}
                  @useEvent={{@useEvent}}
                  @event={{event}}
                  @triggerEvent={{this.triggerEvent}}
                  @showSelectWorkInstructionModal={{this.showSelectWorkInstructionModal}}
                  @disabled={{@disabled}}
                  @bypassDelayTime={{withDefault @bypassDelayTime true}}
                  @resetTimeout={{withDefault @resetTimeout 400}}
                />
              </panes.pane>
            {{/each}}
          </tabs.panes>
        </NoRouteTabs>
      {{else}}
        <ConfigurationFields
          class="p-3"
          @configLocation={{this.configLocation}}
          @jemConfiguration={{@jemConfiguration}}
          @showSelectWorkInstructionModal={{this.showSelectWorkInstructionModal}}
          @disabled={{@disabled}}
          @bypassDelayTime={{withDefault @bypassDelayTime true}}
          @resetTimeout={{withDefault @resetTimeout 400}}
        />
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
